import { axiosClient } from "./client";
import { GET_PAYMENT_INTENT, GET_POINTS_PLANS, GET_PURCHASE_HISTORY } from "./client/endpoints";
import { PaymentIntentPayload } from "./service-models/purchase";

const getPaymentIntent = async (data: PaymentIntentPayload): Promise<any> => {
  return await axiosClient.post<any>(GET_PAYMENT_INTENT, data);
};
const getPurchaseHistory = async (): Promise<any> => {
  return await axiosClient.post<any>(GET_PURCHASE_HISTORY);
};
const getPointsPlans = async (): Promise<any> => {
 return await axiosClient.get<any>(GET_POINTS_PLANS);
};
const PurchaseService = {
  getPaymentIntent,
  getPurchaseHistory,
  getPointsPlans
};
export default PurchaseService;
